$('#add-poll').on('click', function(event) {
  $('#poll-panel').slideToggle(250);
});

$('#poll-panel').on('click', '.add-questions', function(event) {
  $('.input-holder-poll').last().
  clone().
  addClass('extra').
  appendTo('.option-holder');
  $('.input-holder-poll:last-child input').val('');
});

$('.panel').on('click', '.remove-question', function(event) {
  $('.input-holder-poll:last-child').remove();
});

setTimeout( function () {
  if ( $('#poll_option_text').val() ) {
    $('#poll-panel').show(250);
  }
}, 300);

$('.default-submit-action, .button').click(function(event) {
  $('#poll_option_text').empty();
  $('.poll_option_input').each(function() {
    $('#poll_option_text').append($(this).val() + "\n");
  });
});
